import { useState } from "react";
import { getPreferenceFromCache, setPreference } from "src/services/PreferenceStore";
import { ColumnsService } from "src/utils/ColumnsService";
import {
    applyVisibleAuditLogColumns,
    AUDIT_LOG_GRID_KEY,
    isAuditLogDensity,
    visibilityFromEntries,
    visibilityToEntries,
    type AuditLogColumnId,
    type AuditLogColumnVisibility,
    type AuditLogDensity,
} from "./auditLogTablePreferences";

const DENSITY_PREFERENCE_KEY = "auditLogDensity";

export type AuditLogTablePreferences = {
    columnVisibility: AuditLogColumnVisibility;
    setVisibleColumns: (selected: AuditLogColumnId[]) => void;
    density: AuditLogDensity;
    setDensity: (density: AuditLogDensity) => void;
};

export const useAuditLogTablePreferences = (): AuditLogTablePreferences => {
    const [columnVisibility, setColumnVisibility] = useState<AuditLogColumnVisibility>(() =>
        visibilityFromEntries(ColumnsService.getColumnVisibility(AUDIT_LOG_GRID_KEY)),
    );

    const [density, setDensityState] = useState<AuditLogDensity>(() => {
        const stored = getPreferenceFromCache<unknown>("ui", DENSITY_PREFERENCE_KEY);

        return isAuditLogDensity(stored) ? stored : "compact";
    });

    const setVisibleColumns = (selected: AuditLogColumnId[]) => {
        const nextVisibility = applyVisibleAuditLogColumns(selected);

        setColumnVisibility(nextVisibility);
        ColumnsService.saveColumnVisibility(AUDIT_LOG_GRID_KEY, new Map(visibilityToEntries(nextVisibility)));
    };

    const setDensity = (nextDensity: AuditLogDensity) => {
        setDensityState(nextDensity);
        setPreference("ui", DENSITY_PREFERENCE_KEY, nextDensity);
    };

    return { columnVisibility, setVisibleColumns, density, setDensity };
};
